export const MULTIGRADE_LP_PROMPT_NAME = 'multigradeLp';
export const MULTIGRADE_LP_IPLAN_PROMPT_NAME = 'iplanMultigradeLp';
